import React, { useState, useEffect } from 'react';
import { Button, Modal, Badge } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import DatePicker, { DateObject } from "react-multi-date-picker";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';

const AddMaintenance = ({ show, onClose, refresh }) => {

    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const baseURL = process.env.REACT_APP_API_BASE_URL;

    // service type 
    const [servicetypeoption, setServicetype] = useState([]);
    const [service_type, setServiceType] = useState('');
    useEffect(() => {
        const fetchdata = async () => {
            try {
                const response = await axios.get(`${baseURL}/dropdown/servicetype`);
                const formatted = response.data.data.map(item => ({
                    value: item.sno,
                    label: item.servicetype_name,
                }));
                setServicetype(formatted);
            } catch (error) {
                console.error('Error fetching data', error);
            }
        };

        fetchdata();
    }, []);

    const handleservicetypechange = (selectedOptions) => {
        const ids = selectedOptions.map(option => option.value).join(','); // converts to "1,5,9"
        setServiceType(ids);
    }

    // usestates for fields
    const [service_notes, setServicenotes] = useState('');
    const [service_amount, setServiceamount] = useState('');
    const [service_date, setServicedate] = useState(null);
    const [service_dateDisp, setServicedateDisp] = useState(null);
    const [description, setdescription] = useState('');

    const formatDate = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };

    const [options, setOptions] = useState([]);
    const [selOpt, setSelOPt] = useState(null);
    useEffect(() => {
        const fetchdata = async () => {
            try {
                const response = await axios.get(`${baseURL}/manage_maintenance/drop_down?branch_id=${branch_id}`);
                
                setOptions(response.data);
            } catch (error) {
                console.error('Error fetching data', error);
            }
        };

        if(branch_id){
            fetchdata();
        }
    }, [branch_id]);

    const CustomOption = (props) => {
        const { data, innerRef, innerProps, isFocused, isSelected } = props;

        return (
            <div
                ref={innerRef}
                {...innerProps}
                style={{
                    backgroundColor: isFocused ? '#f1f1f1' : isSelected ? '#e2e2e2' : 'white',
                    padding: '10px 12px',
                    cursor: 'pointer',
                }}
            >
                <div style={{ fontWeight: 600, fontSize: '1rem', color: '#333' }}>
                    {data.label}
                </div>
                {data.subtitle && (
                    <div style={{ fontSize: '0.85rem', color: '#666' }}>
                        {data.subtitle}
                    </div>
                )}
            </div>
        );
    };

    // Custom group heading renderer
    const CustomGroupHeading = (props) => (
        <div style={{
            fontWeight: '700',
            fontSize: '1rem',
            color: '#000',
            background: '#f8f9fa',
            padding: '6px 12px',
            borderBottom: '1px solid #ddd',
        }}>
            {props.children}
        </div>
    );

    // Custom styles for control + options
    const customStyles = {
        menu: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    };

    const [errors, setErrors] = useState({});
    const validate = () => {
        const newErrors = {};

        if(!selOpt){
            newErrors.opt = "This Field is Required.";
        }

        if (!service_type) {
            newErrors.type = "This Field is Required.";
        }

        if (!service_notes) {
            newErrors.notes = "This Field is Required.";
        }

        if (!service_amount) {
            newErrors.amt = "This Field is Required.";
        }

        if (!service_date) {
            newErrors.date = "This Field is Required.";
        }

        return newErrors;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        } else {
            setErrors({});
        }

        let postdata = {
            branch_id: branch_id,
            maintenance_type: selOpt.type,
            vehicle_id: selOpt.value,
            service_type: service_type,
            service_notes: service_notes,
            service_amount: service_amount,
            upcomming_maintanence_date: service_date,
            description: description,
        }

        axios.post(`${baseURL}/manage_maintenance`, postdata)
            .then(response => {
                refresh();
                onClose();
                toast.success("Schedule Created Successfully!");
            }).catch(error => {
                onClose();
                console.log(error);
                toast.error("Schedule Creation Failed");
            });

    };

    return (
        <Modal show={show} size="lg"  >
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Maintenance Schedule</h3>
                    <Button variant="" type="button" className="close px-6 py-2 text-white" data-dismiss="modal" onClick={onClose}>
                        <span>×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className='row'>

                        <div className="col-lg-6 mb-3">
                            <label className="text-black font-w500 fs-7">Vehicle or Machinery <span className="required">*</span></label>
                            <Select placeholder="Select Vehicle or Machinery"
                                options={options}
                                styles={customStyles}
                                onChange={setSelOPt}
                                components={{
                                    Option: CustomOption,
                                    GroupHeading: CustomGroupHeading,
                                }}
                            />
                            {errors.opt && <div className="text-danger fs-8 mt-1">{errors.opt}</div>}
                        </div>

                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Name</label>
                            <label className='text-black fs-6 font-w500'>{selOpt ? selOpt.label : '-'}{selOpt ? ', ' + selOpt.subtitle : ''}</label>
                        </div>

                        <div className='col-lg-12 mb-3'>
                            <label className="text-black font-w500 fs-7">Service Type<span className="required">*</span></label>
                            <Select placeholder='Select Service Type'
                                onChange={handleservicetypechange}
                                options={servicetypeoption}
                                isMulti
                            />
                            {errors.type && <div className="text-danger fs-8 mt-1">{errors.type}</div>}
                        </div>

                        <div className="col-lg-12 mb-3">
                            <label className="text-black font-w500 fs-7">Service Notes<span className="required">*</span></label>
                            <textarea rows={4} className="form-control mw-auto" name="comment" placeholder="Description"
                                maxLength={300}
                                value={service_notes}
                                onChange={(e) => setServicenotes(e.target.value)}
                            />
                            {errors.notes && <div className="text-danger fs-8 mt-1">{errors.notes}</div>}
                        </div>

                        <div className="col-lg-6 mb-3">
                            <label className="text-black font-w500 fs-7">Service Amount<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Service Amount"
                                maxLength={10}
                                value={service_amount}
                                onChange={(e) => {
                                    const onlyNums = e.target.value.replace(/[^0-9]/g, '');
                                    setServiceamount(onlyNums);
                                }}
                            />
                            {errors.amt && <div className="text-danger fs-8 mt-1">{errors.amt}</div>}
                        </div>

                        <div className="col-lg-6 mb-3">
                            <label className="text-black font-w500 fs-7">Description</label>
                            <textarea rows={4} className="form-control mw-auto" name="comment" placeholder="Description"
                                maxLength={255}
                                value={description}
                                onChange={(e) => setdescription(e.target.value)}
                            />
                        </div>

                        <label className="text-black font-w500 fs-5 mb-3">UpComing Maintenance Schedule</label>
                        <div className="col-lg-6 mb-3">
                            <label className="text-black font-w500 fs-7 ">Upcoming Maintenance Date<span className="required">*</span></label>
                            <div className='datepicker-wrapper d-flex'>
                                <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                <DatePicker placeholder='Select Upcoming Maintenance Date'
                                    format="DD-MM-YYYY"
                                    value={service_dateDisp}
                                    minDate={new Date().setHours(0, 0, 0)}
                                    onChange={(date) => {
                                        setServicedateDisp(date);
                                        const formattedDate = date.format('YYYY-MM-DD');
                                        setServicedate(formattedDate);
                                    }}
                                />
                            </div>
                            {errors.date && <div className="text-danger fs-8 mt-1">{errors.date}</div>}
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>Maintenance Schedule<i className="fas fa-angle-double-right ms-2"></i></Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default AddMaintenance;
